/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

/**
 * Base body for bulk pause / resume / cancel.
 */
export interface BulkEnrollmentActionRequest {
  /**
     * @minItems 1
     * @maxItems 200
     */
  enrollment_ids: string[];
}
